import { AgentSummary } from '@/modules/gpt-chats/types/agent.service.type';
import { AgentCardGridView } from './agent-card-grid-view';
import { AgentCardListView } from './agent-card-list-view';

interface AgentCardProps {
  agent: AgentSummary;
  view?: 'grid' | 'list';
}

export const AgentCard = ({ agent, view = 'grid' }: AgentCardProps) => {
  if (view === 'list') {
    return <AgentCardListView agent={agent} />;
  }
  return <AgentCardGridView agent={agent} />;
};
